export default "__VITE_ASSET__CpNolwVo__"